import styled from 'styled-components';
import { Typ40 } from 'dc/Typ';
import IcoW01 from 'dc/IcoW01';

type WrapperProps = {
  backgroundImage?: string;
  onClick?: () => void;
};

export const Wrapper = styled.div<WrapperProps>`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding: 60px 16px 0;
  ${props =>
    props.backgroundImage
      ? `background-image: url(${props.backgroundImage});`
      : ''}
  border-radius: 16px;
  width: 100%;
  max-width: 288px;
  min-height: 272px;
  text-align: center;
  cursor: ${props => (props.onClick ? 'pointer' : 'default')};
  &::before {
    content: '';
    background: rgba(0, 0, 0, 0.5);
    background-size: cover;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    border-radius: 16px;
  }
`;

export const Title = styled.span`
  position: relative;
  font-size: 60px;
  line-height: 120%;
  font-weight: bold;
  margin: 0 0 8px 0;
  color: #fff;
`;

export const SubHeader = styled(Typ40)`
  position: relative;
  color: #fff;
`;

export const Icon = styled(IcoW01)`
  position: absolute;
  bottom: 8px;
  right: 0;
`;
